import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable, catchError, map, of} from 'rxjs';
import {Restricao} from '../model/restricao.model';
import { RESTRICAO_OCULTAR_NUMERO, ROTINA_CONTATO } from '../util/restricao.constantes';

@Injectable({
  providedIn: 'root'
})
export class RestricaoService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/restricao`;

  buscarRestricoesPorRotina(rotinaId: number): Observable<Restricao[]> {
    return this.http.get<Restricao[]>(`${this.urlBase}/buscar/rotina/${rotinaId}`);
  }

  buscarOcultarNumeroCelular(): Observable<boolean> {
    return this.buscarRestricoesPorRotina(ROTINA_CONTATO).pipe(
      map(restricoes => (restricoes ?? []).some(r => r.permite && r.chave === RESTRICAO_OCULTAR_NUMERO)),
      catchError(() => of(false))
    );
  }
}
